export default function removeKeyFromObj(originalObj, keyToRemove) {
  return Object.keys(originalObj)
    .filter((key) => key !== keyToRemove)
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: originalObj[key],
      }),
      {}
    );
}
